import axios from "axios";

const apiEndpoint = process.env.REACT_APP_API_ENDPOINT;

export function fetchAppData(langCode ) {
    const url = apiEndpoint + '/country/settings?langCode=' +  langCode;
    return  axios.get(url);
  }